import React from 'react';
import { StatCoverageTypes } from '@ligr/api-v2';
import { Match } from '../../../../../api-types';
import { Select } from '../../../../Select';
import { TriggerProps } from '@ligr/themes/lib/sports/themes/rugbyunion1/Templates/TeamStats/types';
import './style.scss';

interface TeamStatsCustomProps {
  value?: TriggerProps;
  onChange: (update: TriggerProps) => any;
  match: Match;
  disabled?: boolean;
}

// FULLY CONTROLLED ONLY
export const TeamStats: React.FunctionComponent<TeamStatsCustomProps> = ({ disabled, onChange, value = {}, match }) => {
  return (
    <div className="teamstats">
      <div className="teamstats__period">
        <Select
          disabled={disabled}
          value={value.period}
          onChange={event => {
            // @ts-ignore
            onChange({ ...value, periodCode: event.target.value });
          }}
          label="Period"
          options={[
            {
              value: '',
              label: 'Total'
            },
            ...match.summary.periods
              .filter(({ status, started }) => status === 'live' && started)
              .map(period => ({
                label: period.name,
                value: period.code
              }))
          ]}
        />
      </div>
      <div className="teamstats__preset">
        <Select
          disabled={disabled}
          value={value.dataPreset}
          onChange={event => {
            // @ts-ignore
            onChange({ ...value, dataPreset: event.target.value });
          }}
          label="Preset"
          // @ts-ignore
          options={[
            { value: 'scoreAndCards', label: 'Score & Cards' },
            match.config.dataCoverage.stats === StatCoverageTypes.standard
              ? {
                  value: 'additional',
                  label: 'Additional'
                }
              : undefined
          ].filter(val => val)}
        />
      </div>
    </div>
  );
};
